import React from 'react';
import Input from "../input/Input";
import PropTypes from 'prop-types';
import clsx from "clsx";
import styles from './InputGroup.module.scss';
import {HelpIcon} from "../../icons";
import ReactTooltip from "react-tooltip";

export const InputGroup = (props) => {

  const getBorderRadius = (type) => {
    if(type === 'input') {
      if(leading && trailing) return 0;
      else if(leading) return `0 ${borderRadius} ${borderRadius} 0`;
      else if(trailing) return `${borderRadius} 0 0 ${borderRadius}`;
    }

    if(type === 'leading') return `${borderRadius} 0 0 ${borderRadius}`;
    else if(type === 'trailing') return `0 ${borderRadius} ${borderRadius} 0`;
    else return borderRadius;
  };

  const {
    leading,
    className,
    inputClassName = 'mb-0',
    trailingClassName,
    label,
    helpLabel,
    required,
    error,
    borderRadius = '.25rem',
    trailing,
    trailingTpl = (trailing &&
      <div className="input-group-append">
        <span className={clsx("input-group-text", trailingClassName)} style={{borderRadius: getBorderRadius('trailing')}}>{trailing}</span>
      </div>),
    ...other
  } = props;


  return (
    <div className={styles.inputGroup}>

      <ReactTooltip id='help-label' type="light"  borderColor="var(--primary)" textColor='var(--primary)' border effect="solid" className="bg-white opacity-1">
        {helpLabel}
      </ReactTooltip>

      {
        label && (
            <label className="flex flex-d-center gap-1">
              {required && <span className="required">*</span>}
              {label}
              {helpLabel && <span data-tip data-for="help-label" style={{ paddingTop: "0.2rem" }}><HelpIcon /></span>}
            </label>
          )
      }
      <div className={clsx('input-group', styles.formGroup, {"is-invalid": error}, className)}>
        {
          leading &&
          <div className="input-group-prepend">
            <span className="input-group-text" style={{borderRadius: getBorderRadius('leading')}}>{leading}</span>
          </div>
        }

        <Input className={inputClassName} style={{borderRadius: getBorderRadius('input')}} {...other}/>

        {
          trailingTpl
        }
      </div>
      {error && <small className={clsx('form-text form-text-error d-flex invalid-feedback')}>{error}</small>}
    </div>
  );
};

InputGroup.propTypes = {
  leading: PropTypes.any,
  trailing: PropTypes.any,
  trailingTpl: PropTypes.any,
  className: PropTypes.string,
  trailingClassName: PropTypes.string
};

InputGroup.defaultProps = {}

export default InputGroup;
